import * as React from 'react';
import { ChipData } from '../../../interfaces/post.interface';
import './post-categories.scss';

interface PostCategoriesPost {
  feedMetadata?: { categories?: string[] | null } | null;
  categories?: string[] | null;
}

const PostCategories = ({ post }: { post: PostCategoriesPost }) => {
  const categories = React.useMemo<ChipData[]>(() => {
    const feedCategories = post?.feedMetadata?.categories;
    const rootCategories = post?.categories;

    const raw = feedCategories?.length
      ? feedCategories
      : rootCategories?.length
        ? rootCategories
        : undefined;

    if (!raw?.length) return [];
    return raw.map((label, key) => ({ key, label }));
  }, [post]);

  return (
    <div className="Stack">
      {categories.map((data) => (
        <span key={data.key} className="chip">
          {data.label}
        </span>
      ))}
    </div>
  );
};

export default PostCategories;
